import Channeltalk from '@/lib/Channeltalk';
import { Pharmacy } from '@/apis/pharmacy/interface';

const channelTalkService = (pharmacy: Pharmacy) => {
  const profile = {
    name: `${pharmacy?.pharmacy?.name} (#${pharmacy?.pharmacy?.id})`,
    mobileNumber: pharmacy?.phone,
    pharmacistId: pharmacy?.id,
    pharmacistName: pharmacy?.pharmacistName,
    pharmacyName: pharmacy?.pharmacy?.name,
    pharmacyJibunAddress: pharmacy?.pharmacy?.jibunAddress,
    pharmacyRoadAddress: pharmacy?.pharmacy?.roadAddress,
    pharmacyDetailAddress: pharmacy?.pharmacy?.detailAddress,
    pharmacyTel: pharmacy?.pharmacy?.tel
  };

  const pluginKey = '18068210-0f77-49a0-a6d3-141d4463807a';
  // 개발 계정 key
  // const pluginKey = '5def1b1a-6773-442f-9a04-068ab4869993';

  const memberId = `pharmacy-${process.env.REACT_APP_SERVICE_TYPE ?? 'P'}-${
    pharmacy?.id
  }`;

  const boot = () => {
    Channeltalk.boot({
      memberId,
      pluginKey,
      profile
    });
  };

  const show = () => {
    Channeltalk.show({
      memberId,
      pluginKey,
      profile
    });
  };

  const shutdown = () => {
    Channeltalk.shutdown();
  };

  return {
    boot,
    show,
    shutdown
  };
};

export default channelTalkService;
